import React from 'react';
import {
  Box, Flex, Heading, Text,
} from '@chakra-ui/react';
import FormColumnHeading from './FormColumnHeading';

interface FormRowProps {
  heading: string;
  subHeading: string;
  // item 648 — content-heavy sections (the RNWY/Crestron venue builder, module grids, pricing
  // preview) waste the ~22% left label column. fullWidth stacks the heading ON TOP and lets the
  // content span the whole page width.
  fullWidth?: boolean;
}
// item 242 (UI pass) — top-align the label column with its content (was center, which
// floated the heading in the middle of multi-row field groups) and give each row a
// consistent gap + vertical rhythm so fields line up across every form.
const FormRow: React.FC<FormRowProps> = ({
  children, heading, subHeading, fullWidth,
}) => {
  if (fullWidth) {
    return (
      <Box py={2} minW={0}>
        <Heading size="sm" pt={2} pb={1}>{heading}</Heading>
        <Text fontSize="xs" color="brand.700" pb={3} maxW="3xl">{subHeading}</Text>
        <Box minW={0}>{children}</Box>
      </Box>
    );
  }
  return (
    <Flex
      direction={{ base: 'column', md: 'row' }}
      align={{ base: 'stretch', md: 'flex-start' }}
      gap={{ base: 0, md: 4 }}
      py={2}
    >
      <FormColumnHeading
        heading={heading}
        subHeading={subHeading}
      />
      <Box flexBasis={{ base: '100%', md: '80%' }} w="100%" minW={0}>
        {children}
      </Box>
    </Flex>
  );
};

FormRow.defaultProps = { fullWidth: false };

export default FormRow;
